module.exports = __webpack_public_path__ + "static/media/spinner.2af6dd6e.svg";